import { Action, AnyAction, configureStore, ThunkAction, ThunkDispatch } from '@reduxjs/toolkit';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import createReducer from './rootReducer';

// @ts-ignore
if (process.env.NODE_ENV === 'development' && module.hot) {
  // @ts-ignore
  module.hot.accept('./rootReducer', () => {
    // biome-ignore lint/style/noCommonJs: <explanation_todo>
    const newRootReducer = require('./rootReducer').default;
    store.replaceReducer(newRootReducer.createReducer());
  });
}

const rootReducer = createReducer({});
export type RootReducer = typeof rootReducer;

const store = configureStore({
  reducer: rootReducer,
  middleware: getDefaultMiddleware => {
    /* if (process.env.NODE_ENV === 'development') {
			const { logger } = require(`redux-logger`);

			return getDefaultMiddleware().concat(logger);
		} */

    return getDefaultMiddleware();
  },
  devTools: process.env.NODE_ENV === 'development',
});

// @ts-ignore
store.asyncReducers = {};

export const injectReducer = (key: string, reducer: any) => {
  // @ts-ignore
  if (store.asyncReducers[key]) {
    return false;
  }

  // @ts-ignore
  store.asyncReducers[key] = reducer;
  // @ts-ignore
  store.replaceReducer(createReducer(store.asyncReducers));
  return store;
};

export default store;
export type RootState = ReturnType<typeof store.getState>;
// createReducer spreads a loosely typed asyncReducers map, which stops RTK inferring
// the thunk middleware into store.dispatch; state it explicitly so thunks stay dispatchable.
export type AppDispatch = ThunkDispatch<RootState, unknown, AnyAction> & typeof store.dispatch;
export type AppThunk<ReturnType = void> = ThunkAction<ReturnType, RootState, unknown, Action<string>>;

export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
